import { render, staticRenderFns } from "./StackedAxisInfo.vue?vue&type=template&id=1151c0f9&scoped=true&"
import script from "./StackedAxisInfo.vue?vue&type=script&lang=js&"
export * from "./StackedAxisInfo.vue?vue&type=script&lang=js&"
import style0 from "./StackedAxisInfo.vue?vue&type=style&index=0&id=1151c0f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151c0f9",
  null
  
)

export default component.exports